import { Link as MuiLink, type LinkProps as MuiLinkProps } from "@mui/material";

import { LINK_MUI_COLOR, LINK_TYPE_VARIANT } from "ui/link/link.constants";
import { LINK_SIZE_SX } from "ui/link/link.styles";
import { type LinkProps } from "ui/link/link.types";
import { mergeSx } from "ui/merge-sx";

/**
 * MUI's `Link` on Figma's: bold, in one of three colours and two sizes, painted on hover and focus by
 * the theme's `MuiLink` entry. The cast is for `to` and `state`, which MUI's non-polymorphic prop type
 * does not know but the `component` they are meant for does.
 */
export const Link = ({ color = "primary", size = "medium", ref, sx, ...rest }: LinkProps) => (
  <MuiLink
    {...(rest as MuiLinkProps)}
    ref={ref}
    color={LINK_MUI_COLOR[color]}
    variant={LINK_TYPE_VARIANT[size]}
    sx={mergeSx(LINK_SIZE_SX[size], sx)}
  />
);
